import {
  AUTEUR_QUALITE,
  INTEGER,
  TEXT,
  THESAURUS,
  TYPE_EVENEMENT,
} from './fields/FieldTypes.js';
import * as TypeThesaurus from './TypeThesaurus.js';

export const THEMATIQUE_TYPES = [
  {
    id: 'LOCALISATION',
    label: 'Localisation',
    icon: 'recherche-experte-localisation',
    fields: [
      {
        id: 'LOCALISATION_DEPARTEMENT',
        label: 'Département',
        type: THESAURUS,
        typeThesaurus: [TypeThesaurus.COMMUNE],
        onlyDepartement: true,
      },
      {
        id: 'LOCALISATION_COMMUNE',
        label: 'Commune',
        type: THESAURUS,
        typeThesaurus: [TypeThesaurus.COMMUNE],
      },
      {
        id: 'LOCALISATION_ADRESSE',
        label: 'Adresse',
        type: TEXT,
      },
      {
        id: 'LOCALISATION_LIEU_DIT',
        label: 'Lieu-dit',
        type: THESAURUS,
        typeThesaurus: [
          TypeThesaurus.LIEU_DIT_NOM,
          TypeThesaurus.LIEU_DIT_PRECISION,
        ],
      },
      {
        id: 'LOCALISATION_MILIEU_IMPLANTATION',
        label: "Milieu d'implantation",
        type: THESAURUS,
        typeThesaurus: [TypeThesaurus.MILIEU_IMPLANTATION],
      },
      {
        id: 'LOCALISATION_EDIFICE_CONSERVATION',
        label: 'Édifice de conservation',
        type: TEXT,
      },
      {
        id: 'LOCALISATION_EMPLACEMENT_DANS_EDIFICE',
        label: "Emplacement dans l'édifice",
        type: TEXT,
      },
      {
        id: 'LOCALISATION_HYDROGRAPHIE',
        label: 'Hydrographie',
        type: THESAURUS,
        typeThesaurus: [TypeThesaurus.HYDROGRAPHIE_NOM],
      },
      {
        id: 'LOCALISATION_AIRE_ETUDE',
        label: "Aire d'étude",
        type: THESAURUS,
        typeThesaurus: [TypeThesaurus.AIRE_ETUDE],
      },
      {
        id: 'LOCALISATION_CANTON',
        label: 'Canton',
        type: THESAURUS,
        typeThesaurus: [TypeThesaurus.CANTON],
      },
    ],
  },
  {
    id: 'AUTEUR',
    label: 'Auteur',
    icon: 'recherche-experte-auteur',
    fields: [
      {
        id: 'AUTEUR_NOM',
        label: 'Nom',
        type: TEXT,
      },
      {
        id: 'AUTEUR_QUALITE',
        label: 'Qualité',
        type: AUTEUR_QUALITE,
      },
      {
        id: 'AUTEUR_JUSTIFICATION_ATTRIBUTION',
        label: "Justification de l'attribution",
        type: THESAURUS,
        typeThesaurus: [TypeThesaurus.JUSTIFICATION_PROFESSION],
      },
    ],
  },
  {
    id: 'HISTORIQUE',
    label: 'Historique',
    icon: 'recherche-experte-historique',
    fields: [
      {
        id: 'HISTORIQUE',
        label: 'Historique',
        type: TEXT,
      },
      {
        id: 'HISTORIQUE_JUSTIFICATION_DATATION',
        label: 'Justification de la datation',
        type: THESAURUS,
        typeThesaurus: [TypeThesaurus.DATATION_JUSTIFICATION],
      },
      {
        id: 'HISTORIQUE_DATATION_PRINCIPALE',
        label: 'Datation principale',
        type: THESAURUS,
        typeThesaurus: [TypeThesaurus.DATATION_PERIODE],
      },
      {
        id: 'HISTORIQUE_DATATION_SECONDAIRE',
        label: 'Datation secondaire',
        type: THESAURUS,
        typeThesaurus: [TypeThesaurus.DATATION_PERIODE],
      },
      {
        id: 'HISTORIQUE_DATE',
        label: 'Date',
        type: INTEGER,
      },
    ],
  },
  {
    id: 'EVENEMENT',
    label: 'Déplacement ou remploi',
    icon: 'recherche-experte-evenement',
    fields: [
      {
        id: 'EVENEMENT_TYPE',
        label: 'Type du déplacement',
        type: TYPE_EVENEMENT,
      },
      {
        id: 'EVENEMENT_COMMUNE',
        label: 'Commune du déplacement',
        type: THESAURUS,
        typeThesaurus: [TypeThesaurus.COMMUNE],
      },
    ],
  },
  {
    id: 'TYPE_OEUVRE',
    label: "Type d'œuvre",
    icon: 'recherche-experte-type-oeuvre',
    fields: [
      {
        id: 'TYPE_OEUVRE_TITRE_COURANT',
        label: 'Titre courant',
        type: TEXT,
      },
      {
        id: 'TYPE_OEUVRE_DENOMINATION',
        label: 'Dénomination',
        type: THESAURUS,
        typeThesaurus: [
          TypeThesaurus.DENOMINATION_OBJET,
          TypeThesaurus.DENOMINATION_ARCHI,
        ],
      },
      {
        id: 'TYPE_OEUVRE_PRECISION_DENOMINATION',
        label: 'Précision sur la dénomination',
        type: TEXT,
      },
      {
        id: 'TYPE_OEUVRE_TITRE_OEUVRE',
        label: "Titre de l'œuvre",
        type: TEXT,
      },
      {
        id: 'TYPE_OEUVRE_GENRE_DU_DESTINATAIRE',
        label: 'Genre du destinataire',
        type: THESAURUS,
        typeThesaurus: [TypeThesaurus.GENRE],
      },
      {
        id: 'TYPE_OEUVRE_VOCABLE',
        label: 'Vocable',
        type: THESAURUS,
        typeThesaurus: [TypeThesaurus.VOCABLE],
      },
      {
        id: 'TYPE_OEUVRE_APPELLATION',
        label: 'Appellation',
        type: THESAURUS,
        typeThesaurus: [
          TypeThesaurus.APPELLATION_ARCHI,
          TypeThesaurus.APPELLATION_OBJET,
        ],
      },
      {
        id: 'TYPE_OEUVRE_DESTINATION',
        label: 'Destination',
        type: THESAURUS,
        typeThesaurus: [TypeThesaurus.DENOMINATION_ARCHI],
      },
    ],
  },
  {
    id: 'DESCRIPTION',
    label: 'Description',
    icon: 'recherche-experte-description',
    fields: [
      {
        id: 'DESCRIPTION',
        label: 'Description',
        type: TEXT,
      },
      {
        id: 'DESCRIPTION_MUR',
        label: 'Mur',
        type: THESAURUS,
        typeThesaurus: [
          TypeThesaurus.MUR_MATERIAU_GROS_OEUVRE,
          TypeThesaurus.MUR_MISE_EN_OEUVRE,
          TypeThesaurus.MUR_REVETEMENT,
        ],
      },
      {
        id: 'DESCRIPTION_TOIT',
        label: 'Toit',
        type: THESAURUS,
        typeThesaurus: [TypeThesaurus.TOIT],
      },
      {
        id: 'DESCRIPTION_PLAN',
        label: 'Plan',
        type: THESAURUS,
        typeThesaurus: [TypeThesaurus.PLAN],
      },
      {
        id: 'DESCRIPTION_ETAGE',
        label: 'Étage',
        type: THESAURUS,
        typeThesaurus: [TypeThesaurus.ETAGE],
      },
      {
        id: 'DESCRIPTION_COUVREMENT',
        label: 'Couvrement',
        type: THESAURUS,
        typeThesaurus: [
          TypeThesaurus.COUVREMENT_AFFIXE,
          TypeThesaurus.COUVREMENT_VALEUR,
        ],
      },
      {
        id: 'DESCRIPTION_ELEVATION',
        label: 'Élévation',
        type: THESAURUS,
        typeThesaurus: [TypeThesaurus.ELEVATION],
      },
      {
        id: 'DESCRIPTION_COUVERTURE',
        label: 'Couverture',
        type: THESAURUS,
        typeThesaurus: [
          TypeThesaurus.COUVERTURE_FORME,
          TypeThesaurus.COUVERTURE_PARTIE_TOIT,
          TypeThesaurus.COUVERTURE_TYPE,
        ],
      },
      {
        id: 'DESCRIPTION_ESCALIER',
        label: 'Escalier',
        type: THESAURUS,
        typeThesaurus: [
          TypeThesaurus.ESCALIER_EMPLACEMENT,
          TypeThesaurus.ESCALIER_FORME,
          TypeThesaurus.ESCALIER_STRUCTURE,
        ],
      },
      {
        id: 'DESCRIPTION_AUTRES_ORGANES_CIRCULATION',
        label: 'Autres organes de circulation',
        type: THESAURUS,
        typeThesaurus: [TypeThesaurus.AUTRE_ORGANE_CIRCULATION],
      },
      {
        id: 'DESCRIPTION_ENERGIE',
        label: 'Énergie',
        type: THESAURUS,
        typeThesaurus: [
          TypeThesaurus.ENERGIE_MACHINE,
          TypeThesaurus.ENERGIE_NATURE,
          TypeThesaurus.ENERGIE_ORIGINE,
        ],
      },
      {
        id: 'DESCRIPTION_COUVERT_ET_DECOUVERT_JARDIN',
        label: 'Couvert et découvert de jardin',
        type: THESAURUS,
        typeThesaurus: [TypeThesaurus.JARDIN],
      },
      {
        id: 'DESCRIPTION_CATEGORIE',
        label: 'Catégorie',
        type: THESAURUS,
        typeThesaurus: [TypeThesaurus.CATEGORIE],
      },
      {
        id: 'DESCRIPTION_STRUCTURE',
        label: 'Structure',
        type: THESAURUS,
        typeThesaurus: [
          TypeThesaurus.STRUCTURE_AFFIXE,
          TypeThesaurus.STRUCTURE_LIBELLE,
        ],
      },
      {
        id: 'DESCRIPTION_MATERIAU',
        label: 'Matériau',
        type: THESAURUS,
        typeThesaurus: [
          TypeThesaurus.MATERIAU_AFFIXE,
          TypeThesaurus.MATERIAU_PRINCIPAL,
          TypeThesaurus.MATERIAU_TECHNIQUE,
        ],
      },
      {
        id: 'DESCRIPTION_TYPOLOGIE',
        label: 'Typologie',
        type: THESAURUS,
        typeThesaurus: [TypeThesaurus.TYPOLOGIE],
      },
      {
        id: 'DESCRIPTION_TECHNIQUE_DECOR',
        label: 'Technique de décor',
        type: THESAURUS,
        typeThesaurus: [TypeThesaurus.TECHNIQUE],
      },
      {
        id: 'DESCRIPTION_REPRESENTATION',
        label: 'Représentation',
        type: THESAURUS,
        typeThesaurus: [
          TypeThesaurus.REPRESENTATION_CARACTERE_GENERAL,
          TypeThesaurus.REPRESENTATION_SUJET,
          TypeThesaurus.REPRESENTATION_SYMBOLE,
          TypeThesaurus.REPRESENTATION_THEME,
          TypeThesaurus.REPRESENTATION_VALEUR,
        ],
      },
      {
        id: 'DESCRIPTION_PRECISION_REPRESENTATION',
        label: 'Précision sur la représentation',
        type: TEXT,
      },
      {
        id: 'DESCRIPTION_INSCRIPTION_ET_MARQUE',
        label: 'Inscription et marque',
        type: THESAURUS,
        typeThesaurus: [
          TypeThesaurus.INSCRIPTION_AFFIXE,
          TypeThesaurus.INSCRIPTION_VALEUR,
        ],
      },
      {
        id: 'DESCRIPTION_PRECISION_INSCRIPTION',
        label: 'Précision sur l’inscription',
        type: TEXT,
      },
      {
        id: 'DESCRIPTION_ETAT_CONSERVATION',
        label: 'État de conservation',
        type: THESAURUS,
        typeThesaurus: [
          TypeThesaurus.ETAT_CONSERVATION_ARCHI,
          TypeThesaurus.ETAT_CONSERVATION_OBJET,
        ],
      },
      {
        id: 'DESCRIPTION_PRECISION_ETAT_CONSERVATION',
        label: "Précision sur l'état de conservation",
        type: TEXT,
      },
    ],
  },
  {
    id: 'STATUT_INTERET_PROTECTION',
    label: 'Statut, intérêt et protection',
    icon: 'recherche-experte-statut-interet-protection',
    fields: [
      {
        id: 'STATUT_INTERET_PROTECTION_STATUT_PROPRIETE',
        label: 'Statut de la propriété',
        type: THESAURUS,
        typeThesaurus: [TypeThesaurus.STATUT],
      },
      {
        id: 'STATUT_INTERET_PROTECTION_INTERET_OEUVRE',
        label: 'Intérêt de l’œuvre',
        type: THESAURUS,
        typeThesaurus: [TypeThesaurus.INTERET_OEUVRE],
      },
      {
        id: 'STATUT_INTERET_PROTECTION_SITES',
        label: 'Sites',
        type: THESAURUS,
        typeThesaurus: [TypeThesaurus.SITE_PROTECTION],
      },
      {
        id: 'STATUT_INTERET_PROTECTION_PROTECTION',
        label: 'Protection',
        type: THESAURUS,
        typeThesaurus: [
          TypeThesaurus.PROTECTION_OEUVRE_ARCHI,
          TypeThesaurus.PROTECTION_OEUVRE_OBJET,
        ],
      },
      {
        id: 'STATUT_INTERET_PROTECTION_REFERENCE_PATRIARCHE',
        label: 'Référence Patriarche',
        type: TEXT,
      },
      {
        id: 'STATUT_INTERET_PROTECTION_REFERENCE_MONUMENTS_HISTORIQUES',
        label: 'Référence Monuments Historiques',
        type: TEXT,
      },
      {
        id: 'STATUT_INTERET_PROTECTION_PRECISIONS_PROTECTION',
        label: 'Précisions sur la protection',
        type: TEXT,
      },
    ],
  },
];

export const THEMATIQUE_TYPES_LABEL_BY_ID = THEMATIQUE_TYPES.reduce(
  (acc, thematiqueType) => ({
    ...acc,
    [thematiqueType.id]: thematiqueType.label,
  }),
  {},
);

export const THEMATIQUE_TYPES_ICON_BY_ID = THEMATIQUE_TYPES.reduce(
  (acc, thematiqueType) => ({
    ...acc,
    [thematiqueType.id]: thematiqueType.icon,
  }),
  {},
);

export const THEMATIQUE_TYPES_FIELDS_BY_ID = THEMATIQUE_TYPES.reduce(
  (acc, thematiqueType) => ({
    ...acc,
    [thematiqueType.id]: thematiqueType.fields,
  }),
  {},
);

export const FIELD_LABEL_BY_ID = THEMATIQUE_TYPES.flatMap(
  (thematiqueType) => thematiqueType.fields,
).reduce(
  (acc, field) => ({
    ...acc,
    [field.id]: field.label,
  }),
  {},
);

export const FIELD_BY_ID = THEMATIQUE_TYPES.flatMap(
  (thematiqueType) => thematiqueType.fields,
).reduce(
  (acc, field) => ({
    ...acc,
    [field.id]: field,
  }),
  {},
);

export const FIELD_IDS = THEMATIQUE_TYPES.flatMap(
  (thematiqueType) => thematiqueType.fields,
).map((field) => field.id);
